import constCommon from '@/_consts.js';

const defaultState = {
  type: null,
  flow: constCommon.mfaFlow.init,
  login: {},
  mfaData: {}
};

export default defaultState;



// WEBPACK FOOTER //
// ./src/store/modules/mfa/defaultState.js